import { Column, Row } from "components/styles";
import { TextData } from "views/components/Schedules/components/UpdateActivityPopup/styles";
import PCContent from "./PCContent/PCContent";
import GroupRoomContent from "./GroupRoomContent/GroupRoomContent";
import TabletContent from "./TabletContent/TabletContent";
import PhoneIcon from "icons/PhoneIcon";
import PieChartIcon from "icons/PieChartIcon";
import { RESOURCES_CONSTANTS } from "config/constants";
import { FieldIconWrapper } from "views/components/Schedules/styles";

const { RESOURCE_TYPES_IDS } = RESOURCES_CONSTANTS;

export const RESOURCE_TYPE_RESERVATION_ICONS = {
    [RESOURCE_TYPES_IDS.TABLET]: <PhoneIcon size={16}/>,
    [RESOURCE_TYPES_IDS.PC]: <PieChartIcon size={16}/>,
    [RESOURCE_TYPES_IDS.GROUP_ROOM]: <PieChartIcon size={16}/>
};
const ResourceData = ({
    resource
}) => {
    const views = {
        [RESOURCE_TYPES_IDS.TABLET]: <TabletContent {...resource}/>,
        [RESOURCE_TYPES_IDS.PC]: <PCContent {...resource}/>,
        [RESOURCE_TYPES_IDS.GROUP_ROOM]: <GroupRoomContent {...resource}/>,
    };
    return (
        <Column>
            <Row 
                width="100%" 
                gap="8px" 
                justifyContent="flex-start"
                wrap="nowrap"
                marginTop="5px">
                <FieldIconWrapper>
                    {RESOURCE_TYPE_RESERVATION_ICONS[resource.type.id]}
                </FieldIconWrapper>
                <TextData>{resource.type.name} (Cambia según disponibilidad)</TextData>
            </Row>
            {views[resource.type.id]}
        </Column>
    );
}

export default ResourceData;